import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import NormalLayout from 'components/Layouts/NormalLayout'
import useAuth from 'hooks/useAuth'
import BankLoginCard from './BankLoginCard'

const BankLogin = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleLoginBank = async (username: string) => {
    setLoading(true)
    try {
      await auth.login(username)
      navigate('/dashboard')
    } catch (error) {
      console.error(error)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (auth.isAuth()) {
      navigate('/dashboard')
    }
  }, [auth])

  return (
    <NormalLayout>
      <div className="min-h-[calc(100vh-180px)] flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-16">
        <div className="w-full lg:w-1/2 text-center lg:text-left">
          <h1 className="heading-1 mb-4">
            <span className="gradient-text">Send money</span>
            <br />
            anywhere, instantly
          </h1>
          <p className="text-balance text-lg max-w-md mx-auto lg:mx-0">
            Instant, secure and almost zero cost forex settlement powered by xave.co's FXPool technology.
          </p>
          <div className="flex flex-wrap gap-6 mt-8 justify-center lg:justify-start">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-success-100 flex items-center justify-center">
                <svg className="w-5 h-5 text-success-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-neutral-700 font-medium">1 second settlement time</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-success-100 flex items-center justify-center">
                <svg className="w-5 h-5 text-success-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <span className="text-neutral-700 font-medium">Bank Grade Custody</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-full bg-success-100 flex items-center justify-center">
                <svg className="w-5 h-5 text-success-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span className="text-neutral-700 font-medium">0.05% per forex tx</span>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-[420px]">
          <BankLoginCard handleLoginBank={handleLoginBank} loading={loading} />
        </div>
      </div>
    </NormalLayout>
  )
}

export default BankLogin
